( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '.team-member-bio' ).forEach( function( bio ) {
        const media = bio.querySelector( '.team-member-bio__media' );
        const image = bio.querySelector( '.team-member-bio__image' );
        const content = bio.querySelector( '.team-member-bio__content-inner' );

        if ( !media || !image || !content ) {
          return;
        }

        const updateStickyState = function() {
          image.classList.toggle( 'is-sticky', content.offsetHeight > image.offsetHeight );
        };

        updateStickyState();

        if ( 'ResizeObserver' in window ) {
          const observer = new ResizeObserver( updateStickyState );
          observer.observe( media );
          observer.observe( content );
        } else {
          window.addEventListener( 'resize', updateStickyState );
        }

        if ( document.fonts ) {
          document.fonts.ready.then( updateStickyState );
        }
      } );
    },
  };

  app.registerComponent( 'team-member-bio', COMPONENT );
} )( app );
